module.exports = __webpack_public_path__ + "static/media/p8.0e360239.jpg";